import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'costCenter';

const costCenterService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, code) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(code)}`,
      data,
    });
  },
};
export default costCenterService;
